(() => {
  const mounted = new WeakMap();

  function mount(root) {
    if (mounted.has(root)) return;
    const nav = root.querySelector('[data-cf-navigation]');
    if (!nav) return;
    const controller = new AbortController();
    const { signal } = controller;
    const disclosures = [...nav.querySelectorAll('header-menu > details')];
    const triggers = [...nav.querySelectorAll(':scope > ul > li > a, :scope > ul > li > header-menu > details > summary')];
    const breakpoint = window.matchMedia('(min-width: 990px)');
    let geometryFrame = 0;

    function measure() {
      cancelAnimationFrame(geometryFrame);
      geometryFrame = requestAnimationFrame(() => {
        const header = root.closest('.section-header') || root;
        const bottom = Math.max(0, header.getBoundingClientRect().bottom);
        const viewportBottom = window.visualViewport
          ? window.visualViewport.height + window.visualViewport.offsetTop
          : window.innerHeight;
        const available = Math.max(0, viewportBottom - bottom);
        root.style.setProperty('--cf-panel-height', `${Math.max(0, available - 16)}px`);
        root.style.setProperty('--cf-drawer-height', `${available}px`);
        root.preventHide = disclosures.some((details) => details.open);
      });
    }

    function close(details, returnFocus = false) {
      const trigger = details.querySelector(':scope > summary');
      const component = details.closest('header-menu');
      if (typeof component?.close === 'function') component.close();
      else details.open = false;
      trigger?.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger?.focus();
    }

    function closeAll(except) {
      disclosures.forEach((details) => {
        if (details !== except && details.open) close(details);
      });
      measure();
    }

    disclosures.forEach((details) => {
      details.addEventListener('toggle', () => {
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
        if (details.open) closeAll(details);
        measure();
      }, { signal });
    });

    nav.addEventListener('keydown', (event) => {
      const triggerIndex = triggers.indexOf(event.target);
      if (event.key === 'Escape') {
        const current = event.target.closest('details[open]');
        if (!current || !nav.contains(current)) return;
        event.preventDefault();
        event.stopPropagation();
        close(current, true);
        measure();
        return;
      }
      if (triggerIndex === -1) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        triggers[(triggerIndex + direction + triggers.length) % triggers.length].focus();
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const details = event.target.closest('details');
      if (!details) return;
      event.preventDefault();
      details.open = true;
      closeAll(details);
      requestAnimationFrame(() => {
        const links = [...details.querySelectorAll('.cf-nav-panel a[href]')];
        const destination = event.key === 'ArrowUp' ? links.at(-1) : links[0];
        destination?.focus();
      });
    }, { signal });

    document.addEventListener('pointerdown', (event) => {
      if (!nav.contains(event.target)) closeAll();
    }, { signal });

    window.addEventListener('resize', measure, { passive: true, signal });
    window.addEventListener('scroll', () => {
      if (disclosures.some((details) => details.open)) measure();
    }, { passive: true, signal });
    window.visualViewport?.addEventListener('resize', measure, { passive: true, signal });
    breakpoint.addEventListener('change', () => {
      closeAll();
      const drawer = root.querySelector('header-drawer');
      const mainDetails = drawer?.querySelector(':scope > details');
      if (breakpoint.matches && mainDetails?.open && typeof drawer.closeMenuDrawer === 'function') {
        const trigger = mainDetails.querySelector(':scope > summary');
        drawer.closeMenuDrawer(new Event('resize'), trigger);
        trigger?.setAttribute('aria-expanded', 'false');
      }
      measure();
    }, { signal });

    const observer = new ResizeObserver(measure);
    observer.observe(root);
    mounted.set(root, () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(geometryFrame);
    });
    measure();
  }

  function initialize(scope = document) {
    if (scope instanceof Element && scope.matches('.cf-native-navigation')) mount(scope);
    scope.querySelectorAll('.cf-native-navigation').forEach(mount);
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.cf-native-navigation').forEach((root) => {
      mounted.get(root)?.();
      mounted.delete(root);
    });
  });
})();
